import React from 'react';
import clsx from 'clsx';
import { Element, Link } from '../../../atoms';
import styles from '../breadcrumbs.styles';

/**
 *
 * @type {import('../').BreadcrumbItemType}
 */
const BreadcrumbsItem = ({ children, className, isStatic, ...props }) => {
  if (isStatic) {
    return (
      <Element className={clsx(styles.item, styles.staticItem, className)} {...props}>
        {children}
      </Element>
    );
  }
  return (
    <Link className={clsx(styles.item, className)} {...props}>
      {children}
    </Link>
  );
};

export default BreadcrumbsItem;
